<template>
	<div class="eia-faq-entry">
		<template v-if="faqItem">
			<eia-heading level="h1">{{ title }}</eia-heading>
			<component :is="generatedVueInstance"></component>
		</template>

		<p v-else>
			No FAQ found. Go back...
		</p>

		<router-link
			class="eia-faq-entry__return"
			:to="returnPath">
			<eia-icon name="chevron-left"></eia-icon>
			<span>Back</span>
		</router-link>
	</div>
</template>

<script>
import faqs from '@/copy/faq.js';
import { urlSafe } from '@/utils/string-utils';

export default {
	name: 'eia-faq-entry',

	data() {
		return {
			faqs,
		};
	},

	computed: {
		faqItem() {
			return faqs.find( d => {
				const title = urlSafe( d.title );
				const path = this.$route.path.split( '/' ).pop();

				return path === title;
			} );
		},

		title() {
			return this.faqItem.title;
		},

		body() {
			return this.faqItem.body;
		},

		generatedVueInstance() {
			return this.constructor.super.component( 'faq-body-component', {
				template: `<div><eia-paragraph>${this.body}</eia-paragraph></div>`,
			} );
		},

		author() {
			return this.faqItem.author;
		},

		returnPath() {
			return {
				path: '/faq',
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-faq-entry {
	&__return {
		display: inline-flex;
		align-items: center;
		margin-top: 16px;
		margin-bottom: 16px;

		.eia-icon {
			font-size: 0.7em;
			margin-right: 4px;
		}
	}
}
</style>
